import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd/lib/date-picker';
import type { FormikProps } from 'formik';
import moment from 'moment-timezone';
import React from 'react';

import { ISharedFormValues } from './formik';

interface IDurationOfAccessSectionDatePickerProps {
  fieldName: string;
  formikProps: FormikProps<ISharedFormValues>;
  datePickerProps?: DatePickerProps;
}

export const DurationOfAccessDatePicker = (props: IDurationOfAccessSectionDatePickerProps) => {
  const { fieldName, formikProps, datePickerProps } = props;
  const { isSubmitting, values, setFieldValue } = formikProps;

  const sharedDatePickerProps: DatePickerProps = {
    format: 'MMM D, YYYY h:mma',
    showTime: { use12Hours: true },
    allowClear: false,
    style: { width: '100%' },
    disabled: isSubmitting,
    onChange: (nextDate) => {
      if (nextDate) {
        const convertedNextDate = moment(nextDate)
          // Set timezone WITHOUT changing selected time
          .tz(values.selectedTimezone, true)
          // Round down to exclude extra seconds (which aren't visible)
          .startOf('minute');

        setFieldValue(fieldName, convertedNextDate.toDate());
      } else {
        setFieldValue(fieldName, nextDate);
      }
    },
    showNow: false,
    renderExtraFooter: () => (
      <a
        onClick={() => {
          const convertedNow = moment(new Date())
            // Convert to selected timezone
            .tz(values.selectedTimezone)
            // Round down to exclude extra seconds (which aren't visible)
            .startOf('minute');

          setFieldValue(fieldName, convertedNow.toDate());
        }}
      >
        Now
      </a>
    ),
  };

  return <DatePicker {...sharedDatePickerProps} {...datePickerProps} />;
};
